module.exports = __webpack_public_path__ + "startpage-746fed5a/qrcode-86ebc6a6ef56a670acf49e7e91b0e030.svg";